module.exports = __webpack_public_path__ + "static/media/didiao1.12bba0e6.png";